import { render, staticRenderFns } from "./HeZuoLianMengShuang2.vue?vue&type=template&id=05e83d5e&scoped=true&"
import script from "./HeZuoLianMengShuang2.vue?vue&type=script&lang=js&"
export * from "./HeZuoLianMengShuang2.vue?vue&type=script&lang=js&"
import style0 from "./HeZuoLianMengShuang2.vue?vue&type=style&index=0&id=05e83d5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e83d5e",
  null
  
)

export default component.exports